import { AppSettingsActions } from "@/common/stores/persistingStores/app";
import { useAppSettingsStore } from "@/common/stores/persistingStores/app/appSettingsStore";
import { ServerEvent } from "@/common/notification";
import { useAuth } from "@/hooks/authentication";
import { notificationListener } from "@/hooks/notification";
import { fetchAppSettings } from "@/repository/queryFns/app";
import { useEffect } from "react";

export const useAppSettingsManager = () => {
	const authContext = useAuth();
	const setSettings = useAppSettingsStore(
		(actions: AppSettingsActions) => actions.setSettings
	);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		fetchAppSettings().then(setSettings);
	}, [authContext.isLogged]);

	notificationListener(ServerEvent.SettingsReloaded, () => {
		fetchAppSettings().then(setSettings);
	});
};
